<template>
  <div>
    <slot />
    <div :class="`inline ${$props.alwaysShow ? '' : 'parent-hover-appear'}`">
      <slot name="hover-content" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    alwaysShow: { type: Boolean, default: false },
  },
}
</script>

<style scoped>
.inline {
  display: inline-block;
}
</style>
